import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'

interface Props extends ChildProps {
  badgeText?: string
  badgeType?: BadgeType
  selected?: boolean
  disabled?: boolean
  onClick?(e: React.MouseEvent<HTMLElement>): void
}

const Tab = ({
  children,
  badgeText,
  badgeType = BadgeType.CAUTION,
  selected = false,
  disabled = false,
  onClick
}: Props) => {
  const textClass = clsx(
    disabled
      ? 'text-disabled'
      : selected
      ? 'text-emphasis'
      : 'text-primary hover:text-emphasis-hover active:text-emphasis-active'
  )
  const afterClass = clsx(
    'after:absolute after:w-full after:h-[3px] after:bottom-0 after:rounded-t-[3px] after:inset-x-0 focus:appearance-none',
    !disabled && 'hover:after:bg-fill-emphasis-hover active:after:bg-fill-emphasis-active',
    selected && 'after:bg-fill-emphasis'
  )

  return (
    <li className=' list-none px-1 pt-2'>
      <button
        type='button'
        className={clsx(
          textClass,
          afterClass,
          'outline-default relative inline-flex items-center gap-1 px-2.5 pb-3.5 pt-1.5 focus-visible:-outline-offset-2',
          (selected || disabled) && 'disabled-active-pointer-none'
        )}
        onClick={onClick}
        disabled={disabled}
        tabIndex={selected ? -1 : 0}
      >
        <span className={clsx('text-size-13', selected && 'font-semibold')}>{children}</span>
        {badgeText && !disabled && (
          <Badge size={10} badgeType={badgeType}>
            {badgeText}
          </Badge>
        )}
      </button>
    </li>
  )
}

export default Tab
